<!-- eslint-disable vue/html-self-closing -->
<template>
  <section class="project-leave-form">
    <div class="project-leave-form__content">
      <gf-custom-alert variant="warning">
        <template #body>
          <i class="gf-icon gf-icon-warning mr-1"></i>
          {{ $t('message.attentionDescription') }}
        </template>
      </gf-custom-alert>

      <p>
        {{ $t('projects.leave.description', { title: projectAlias }) }}
      </p>

      <div class="project-leave-form__actions">
        <span
          v-html="
            $t('projects.leave.controlString.description', {
              controlString: controlStringReference
            })
          "
        ></span>
        <div class="mt-1 mb-2">
          <input
            v-model="controlString"
            class="form-control form-control-sm"
            inputmode="text"
            type="text"
            required
          />
          <small
            v-if="formValidationErrors?.controlString"
            class="text-danger"
          >
            {{ formValidationErrors?.controlString }}
          </small>
        </div>
        <button
          type="button"
          class="btn btn-danger btn-block btn-sm"
          :disabled="controlString?.length === 0"
          @click="onLeaveProjectClick"
        >
          <span>{{ $t('projects.leave.title') }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import GfCustomAlert from '@/shared-modules/shared-components/shared/GfCustomAlert';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
import ProjectsMessages from '@/shared-modules/modules/projects/projects.messages';

export default {
  name: 'ProjectLeaveForm',
  components: { GfCustomAlert },
  props: {
    alias: {
      type: String,
      default: ''
    },
    projectAlias: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      controlString: ''
    };
  },
  computed: {
    controlStringReference() {
      return `${this.alias}/${this.projectAlias}`;
    },
    formValidationErrors() {
      return this.$store.getters.getFormErrors(FORM_NAME_ENUMS.LEAVE_PROJECT);
    }
  },
  watch: {
    alias() {
      this.controlString = null;
    },
    projectAlias() {
      this.controlString = null;
    }
  },
  methods: {
    onLeaveProjectClick() {
      this.$emit('submit', { controlString: this.controlString });
    }
  },
  i18n: {
    messages: ProjectsMessages
  }
};
</script>

<style lang="scss">
$this: '.project-leave-form';

#{$this} {
  #{$this}__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
</style>
